var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-loading fade-in"},[_c('img',{staticStyle:{"height":"250px"},attrs:{"src":"/images/pam-graphic.png","alt":"PAM PUSH AND MOTION"}}),_vm._v(" "),_c('h5',{staticClass:"loading-text overline my-2 grey--text text--darken-1"},[_vm._v("\n    Loading "+_vm._s(_vm.loadingDot)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }